export const getInitialCustomerId = () => {
  const INITIAL_CUSOMER_ID_PREFIX = 'FP_customer_';
  const randomNumbers = Math.floor(Math.random() * 10000000000)
    .toString()
    .padStart(10, '0');
  return INITIAL_CUSOMER_ID_PREFIX + randomNumbers;
};
